export default __webpack_public_path__ + "static/media/banner.168b1f96.webp";